var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmarkIcon = function SvgBookmarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M.669 21.094a1.385 1.385 0 0 0 1.658.229l5.697-3.193 5.642 3.186c.323.182.696.229 1.052.128.357-.099.653-.331.833-.651.117-.209.18-.444.18-.681l-.006-13.526c0-2.635-1.694-4.086-4.77-4.086H5.038C2.005 2.5.266 3.927.266 6.415v13.701c-.001.369.143.716.403.978"
  })));
};
export default SvgBookmarkIcon;